import { useProfileModalStore } from '../use-profile-modal-store';

import { ChangePasswordFlow } from './change-password-flow';
import { ChangePhoneFlow } from './change-phone-flow';
import { EditProfileModal } from './edit-profile-modal';

/** Renders whichever account modal `useProfileModalStore` names. Mounted once in `<AppShell>` so a
 *  flow survives in-app navigation (grilling Q1). One branch per flow. */
export function ProfileFlows() {
  const open = useProfileModalStore((s) => s.open);
  const setOpen = useProfileModalStore((s) => s.setOpen);
  if (open === 'edit') return <EditProfileModal onClose={() => setOpen(null)} />;
  if (open === 'phone') return <ChangePhoneFlow />;
  if (open === 'password') return <ChangePasswordFlow />;
  return null;
}
